module.exports = __webpack_public_path__ + "img/logo-dark.89bd5af0.svg";